import React, { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { StepProps } from '../createStateMachine';
import { RemoteInstallFormContext } from '../index';
import css from '../index.module.scss';
import { useLang } from '@/i18n';

const Step3: React.FC<StepProps<RemoteInstallFormContext>> = ({ send, context }) => {
    const { t } = useLang('questionnaire');
    const [selected, setSelected] = useState(context.step3);
    const handleChange = (e) => {
        setSelected(e.target.value as 'yes' | 'no');
    };
    return (
        <div className={css.step}>
            <div className="step-head">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1766458160480/pc_shp2.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1766458160670/m_shp2.jpg"
                />
                <span>{t('step_head')}</span>
            </div>
            <div className="step-info">
                <div className="step-title">
                    <span>*</span>
                    {t('step3_question')}
                </div>
                <label className="step-radio">
                    <input type="radio" name="step" value="yes" checked={selected === 'yes'} onChange={handleChange} />
                    <span>{t('step3_item1')}</span>
                </label>
                <label className="step-radio">
                    <input type="radio" name="step" value="no" checked={selected === 'no'} onChange={handleChange} />
                    <span>{t('step3_item2')}</span>
                </label>
            </div>
            <div className="step-btns">
                <button className="step-btn step-btn-prev" onClick={() => send('BACK')}>
                    {t('btn1')}
                </button>
                <button
                    className={`step-btn step-btn-next ${!selected ? 'step-btn-disabled' : ''}`}
                    onClick={() => {
                        if (!selected) return;
                        send(selected);
                    }}
                >
                    {t('btn2')}
                </button>
            </div>
        </div>
    );
};
export default Step3;
